import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Legacy /onboarding entry. Post-login routing now lives on /dashboard (see
 * Dashboard.tsx), which surfaces every assignment — including empty payer rows —
 * and shortcuts a lone incomplete assignment straight to its onboarding screen.
 * This just forwards there (preserving query params) so existing
 * `next: "/onboarding"` referrers land on the single decision point.
 */
const OnboardingHub: React.FC = () => {
    const location = useLocation();
    return <Navigate to={`/dashboard${location.search}`} replace />;
};

export default OnboardingHub;
